import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import SignInForm from "./sign_in_form";
import LoggedOutFrame from "../../lib/logged_out_frame";
import { Link } from "react-router-dom";
import "./sign_in_page.css";
import { onCaptchaReady } from "../../../lib/captcha";
import { getMegapodURL } from "../../../lib/config";

class SignInPage extends Component {
  state = {
    submitEnabled: false,
  };

  componentDidMount() {
    window.scrollTo({ top: 0, left: 0 });
    onCaptchaReady(() => {
      this.setState({ submitEnabled: true });
    });
  }

  signIn = data => {
    this.props.submitSignIn(data, this.props.forRole);
  };

  render() {
    return (
      <LoggedOutFrame title="Sign In" subTitle="Welcome Back! It's good to see you again.">
        <Row className="sign-up-row">
          <Col xs={12} md={6} mdOffset={3}>
            <SignInForm
              onSubmit={this.signIn}
              isLoading={this.props.isLoading}
              hasError={this.props.hasError}
              errorMessage={this.props.errorMessage}
              user={this.props.user}
              submitEnabled={this.state.submitEnabled}
            />
          </Col>
        </Row>

        <Row className="sign-up-links-row">
          <Col md={3} mdOffset={3} xs={6}>
            <a
              className="redcircle-big-link"
              href={getMegapodURL() + "account-create" + window.location.search}>
              Create Account
            </a>
          </Col>
          <Col md={3} xs={6}>
            <Link className="text-right redcircle-big-link" to="/forgot-password">
              Forgot your password?
            </Link>
          </Col>
        </Row>
      </LoggedOutFrame>
    );
  }
}

export default SignInPage;
